import adminApiClient from '../../api/base/adminApiClient'

export interface User {
  id: number
  username: string
  email: string
  phone: string | null
  nickname: string
  profile_image: string | null
  security_answer: string | null
  is_public: boolean
  location_consent: boolean
  location_consent_at: string | null
  contact_consent: boolean
  contact_consent_at: string | null
  push_notification_consent: boolean
  push_notification_consent_at: string | null
  agree_terms: boolean
  agree_privacy: boolean
  fcm_token_count: number
  /** 기록한 장소 수. 같은 가게를 여러 번 기록해도 한 곳으로 센다 */
  review_count: number
  /** 저장한 장소 수. **그 사람이 직접 담은 것만** (남이 공유 리스트에 넣어준 건 제외) */
  saved_place_count: number
  is_social_login: boolean
  social_provider: string | null
  is_active: boolean
  created_at: string
  updated_at: string
}

export interface GetUsersResponse {
  data: User[]
  current_page: number
  last_page: number
  per_page: number
  total: number
}

export interface GetUsersParams {
  page?: number
  per_page?: number
  search?: string
}

export interface UpdateUserParams {
  username?: string
  email?: string
  nickname?: string
  phone?: string | null
  is_public?: boolean
  is_active?: boolean
  location_consent?: boolean
  contact_consent?: boolean
  push_notification_consent?: boolean
}

export interface UpdateUserResponse {
  message: string
  data: User
}

export const adminUserApi = {
  getUsers: async (params?: GetUsersParams): Promise<GetUsersResponse> => {
    const response = await adminApiClient.get<GetUsersResponse>(
      '/admin/users',
      {
        params,
      }
    )
    return response.data
  },
  updateUser: async (
    id: number,
    params: UpdateUserParams
  ): Promise<UpdateUserResponse> => {
    const response = await adminApiClient.put<UpdateUserResponse>(
      `/admin/users/${id}`,
      params
    )
    return response.data
  },
  deleteUser: async (id: number): Promise<{ message: string }> => {
    const response = await adminApiClient.delete<{ message: string }>(
      `/admin/users/${id}`
    )
    return response.data
  },
}
